module.exports = __webpack_public_path__ + "static/data_bar_7-31d4dae5a5b353d9bbaebfe1e329c06a.png";